import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Tooltip,
  Box,
  Button,
  Typography,
  Drawer,
  Autocomplete,
  TextField,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import Loader from "../../../Components/Loader";
import { CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import { Colors } from "../../../Styles/Colors";
import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";


const active_status = [{ label: "All", value: "" }, { label: "Placed Order", value: "Placed Order" }, { label: "Partialy Delivered", value: "Partialy Delivered" }, { label: "Completely Delivered", value: "Completely Delivered" }]

const StorePurchseInward = () => {
  const EditAccess = CheckAccessFunc("Store", "Purchase", "Purchase Inward", null, "Tab")?.editAccess

  const history = useHistory();
  const location = useLocation();
  const [expandedRow, setExpandedRow] = useState(null);
  const [inwardList, setInwardList] = useState([]);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [isloader, setisloader] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setfilterData] = useState({
    fromDate: "",
    toDate: "",
    dateIndex: 0,
    vendorName: null,
    BillNumber: "",
    PINumber: "",
    status: { label: "All", value: "" }
  });
  const [vendorList, setvendorList] = useState([]);

  useEffect(() => {
    getPurchaseInwardList()
    getVendorList()
    if (location.states?.success_message) {
      successMessage(location.states?.success_message)
      history.push({ states: { ...location?.states, success_message: "" } })
    }
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  const getPurchaseInwardList = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.STORE_PURCHASE_INWARD + `?from_date=${filterData.fromDate}&to_date=${filterData.toDate}&vendor_id=${filterData.vendorName?.id || ""}&pi_number=${filterData.PINumber || ""}&bill_number=${filterData.BillNumber || ""}&status=${filterData.status?.value || ""}`)
        .then((response) => {
          if (response.data.status === 'success') {
            setisloader(false)
            setInwardList(response.data.data || [])
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getVendorList = () => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_VENDOR)
        .then((response) => {
          if (response.data.status === 'success') {
            setvendorList(response.data.data?.filter((item) => item?.is_active) || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  const closeFilter = () => {
    setFilterOpen(false);
  }

  const FilterDate = (from, to, index) => {
    setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
  }

  const GetPrint = (Data = null) => {
    try {
      RestAPIService.getAllPrint(Serviceurls.STORE_PURCHASE_INWARD + `?export_type=pdf&vendor_bill_id=${Data?.vendor_bill_id || ""}&inward_id=${Data?.purchase_inward_id || ""}`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const GetOverallPrint = () => {
    try {
      RestAPIService.getAllPrint(Serviceurls.STORE_PURCHASE_INWARD + `?from_date=${filterData.fromDate}&to_date=${filterData.toDate}&vendor_id=${filterData.vendorName?.id || ""}&pi_number=${filterData.PINumber || ""}&bill_number=${filterData.BillNumber || ""}&status=${filterData.status?.value || ""}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }


  const renderFilterScreen = () => {
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
          <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={filterData.fromDate}
              ToDate={filterData.toDate}
              DateIndex={filterData.dateIndex}
              SelectedDates={FilterDate.bind(this)} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              options={active_status}
              getOptionLabel={(option) => option?.label}
              value={filterData?.status}
              onChange={(event, newValue) => {
                setfilterData({ ...filterData, status: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Active Status'}
                />
              )}
            />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              value={filterData.vendorName ? filterData.vendorName : null}
              options={vendorList}
              getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.vendor_name}
              onChange={(event, newValue) => {
                setfilterData({ ...filterData, vendorName: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Select Vendor'}
                />
              )} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <TextField
              size='small'
              sx={{ width: '20dvw' }}
              label={'PI Number'}
              value={filterData.PINumber ? filterData.PINumber : ""}
              onChange={(e) => {
                setfilterData({ ...filterData, PINumber: e.target.value })
              }} />
          </Box>
          {/* <Box className='eMed_rts_dropdown'>
            <TextField
              size='small'
              sx={{ width: '20dvw' }}
              label={'Bill Number'}
              value={filterData.BillNumber ? filterData.BillNumber : ""}
              onChange={(e) => {
                setfilterData({ ...filterData, BillNumber: e.target.value })
              }} />
          </Box> */}
        </Box>
        <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
          <Button variant='outlined' size="small"
            onClick={() => {
              setfilterData({
                fromDate: "",
                toDate: "",
                dateIndex: 0,
                vendorName: null,
                PrNumber: "",
                status: { label: "All", value: "" }
              })
            }}
            id="eMed_Config_btn">{"Clear"}</Button>
          <Button variant='contained' size="small"
            onClick={() => {
              getPurchaseInwardList();
              setFilterOpen(false);
            }}
            id="eMed_Config_btn">{"Search"}</Button>
        </Stack>
      </Box>
    )
  }

  return (
    <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box sx={{ display: 'flex', justifyContent: "flex-end", marginRight: "1vw", alignItems: "center" }}>
        <Button size='small' disabled={!EditAccess} sx={{ textTransform: 'capitalize' }} variant='contained' onClick={() => { history.push({ pathname: "/StorePurchase/PurchaseInward/Add" }) }}>GRN Entry</Button>
        <Tooltip title={'Filter'} placement="top">
          <IconButton onClick={() => { setFilterOpen(true) }}>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
          </IconButton>
        </Tooltip>
        <Tooltip title={'Print'} placement="top">
          <IconButton onClick={() => { GetOverallPrint() }}          >
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
          </IconButton>
        </Tooltip>
      </Box>

      <TableContainer component={Paper} style={{ height: "72dvh", }}>
        <Table stickyHeader size='small'>
          <TableHead style={{ backgroundColor: "#f5f5f5", height: "5vh" }}>
            <TableRow>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>S.No</TableCell>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>PI Date</TableCell>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>PI No</TableCell>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>Vendor Name</TableCell>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>GST NO</TableCell>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>No Of Items</TableCell>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>Status</TableCell>
              <TableCell align="left" sx={{ padding: 0 }} className='billing_tbl_head'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {inwardList?.length === 0 ?
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <Typography sx={{ marginTop: "5vh" }}>No Records Found</Typography>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
              : inwardList.map((row, index) => (
                <React.Fragment key={row.id}>
                  {/* Parent Row */}
                  <TableRow>
                    <TableCell align="left" sx={{ paddingX: 0, paddingLeft: "1vw" }}>{index + 1}</TableCell>
                    <TableCell align="left" sx={{ paddingX: 0 }}>{row.purchase_order_date ? formatDate(row.purchase_order_date) : "-"}</TableCell>
                    <TableCell align="left" sx={{ paddingX: 0 }}>{row.po_number ? row.po_number : "-"}</TableCell>
                    <TableCell align="left" sx={{ paddingX: 0 }}>{row.vendor_name ? row.vendor_name : "-"}</TableCell>
                    <TableCell align="left" sx={{ paddingX: 0 }}>{row.gst_number ? row.gst_number : "-"}</TableCell>
                    <TableCell align="left" sx={{ paddingX: 0 }}>{row.number_of_items ? row.number_of_items : "-"}</TableCell>
                    <TableCell align="left" sx={{ paddingX: 0 }}>{row.status}</TableCell>
                    <TableCell align="left" sx={{ paddingX: 0 }}>
                      {EditAccess ? <Tooltip title={"GRN Entry"} placement="top" arrow>
                        <IconButton emed_tid={'Store_PI_grnEntry'} className='eMed_usrconf_btn' onClick={() => {
                          history.push({ pathname: "/StorePurchase/PurchaseInward/Add", states: { inward_details: row } })
                        }}>
                          <img src={ImagePaths.StoreGRNentry.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                        </IconButton>
                      </Tooltip> : null}
                      <IconButton onClick={() => handleExpandClick(row.id)}>
                        {expandedRow === row.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  {/* Expandable Child Row */}
                  < TableRow >
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                      <Collapse in={expandedRow === row.id} timeout="auto" unmountOnExit>
                        <Table size="small" style={{ marginBottom: "10px" }}>
                          <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                            <TableRow>
                              <TableCell>Bill date</TableCell>
                              <TableCell>GRN Number</TableCell>
                              <TableCell>Bill Number</TableCell>
                              <TableCell>Bill Amount</TableCell>
                              <TableCell>Delivery Date</TableCell>
                              <TableCell>Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {row?.vendor_bills && row?.vendor_bills.map((item, i) => (
                              <TableRow key={i}>
                                <TableCell>{item.bill_date ? formatDate(item.bill_date) : "-"}</TableCell>
                                <TableCell>{item.grn_number ? item.grn_number : "-"}</TableCell>
                                <TableCell>{item.bill_number ? item.bill_number : "-"}</TableCell>
                                <TableCell>{item.net_amount ? item.net_amount : "-"}</TableCell>
                                <TableCell>{item.delivery_date ? formatDate(item.delivery_date) : "-"}</TableCell>
                                <TableCell>
                                  {EditAccess ? <Tooltip title={"View & Edit GRN"} placement="top" arrow>
                                    <IconButton emed_tid={'Store_PI_grnEntry'} className='eMed_usrconf_btn' onClick={() => {
                                      history.push({ pathname: "/StorePurchase/PurchaseInward/Add", states: { inward_details: row, bill_details: item, for_edit: true } })
                                    }}>
                                      <img src={ImagePaths.StoreViewButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                                    </IconButton>
                                  </Tooltip> : null}
                                  {EditAccess ? <Tooltip title={"PO Return"} placement="top" arrow>
                                    <IconButton emed_tid={'Store_PI_Return'} disabled={!item?.is_finished} className='eMed_usrconf_btn' onClick={() => {
                                      history.push({ pathname: "/StorePurchase/PurchaseReturn", states: { inward_details: row, bill_details: item } })
                                    }}>
                                      <img src={item?.is_finished ? ImagePaths.StorePOreturn.default : ImagePaths.StoreReturnDisable.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                                    </IconButton>
                                  </Tooltip> : null}
                                  <Tooltip title={"Print GRN"} placement="top" arrow>
                                    <Button
                                      onClick={() => { GetPrint(item) }}
                                      className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                      <img src={ImagePaths.PrintIcons.default} alt="print" style={{ width: '1.5vw', height: '1.5vw' }} />
                                    </Button>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
      </TableContainer >
      <Drawer
        anchor={'right'}
        open={filterOpen}
        ModalProps={{ onBackdropClick: closeFilter }}
      >
        {renderFilterScreen()}
      </Drawer>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {isloader ? <Loader loaderOpen={isloader} /> : null}

    </Box>

  );
};

export default StorePurchseInward;
